export const transparencia_item = [
    {
        "transparencia_item_nombre" : "48 Rubros",
        "transparencia_item_url" : "/Transparencia/Rubros"
    },
      {
        "transparencia_item_nombre" : "Convenios",
        "transparencia_item_url" : "/Transparencia/Convenios"
      },
      {
        "transparencia_item_nombre" : "Documentos Normativos",
        "transparencia_item_url" : "/Transparencia/Normativos"
      },
      {
        "transparencia_item_nombre" : "Programa Anual de Desarrollo Archivístico",
        "transparencia_item_url" : "/Transparencia/Pada"
      },
    
];